/**
 * Map dashboard Ops Intelligence rule items → DecisionAction.
 * Only certified LIVE rule output; no freeform or AI rows.
 */

import type { OpsActionItem, OpsPriority } from '../founder-dashboard/ops-intelligence/types';
import type { BusinessArea, DecisionAction, ActionPriority } from './types';

const PRIORITY_MAP: Record<OpsPriority, ActionPriority> = {
  critical: 'critical',
  warning: 'important',
  opportunity: 'opportunity',
};

const AREA_MAP: Record<OpsActionItem['sourceDomain'], BusinessArea> = {
  connect: 'connect',
  orders: 'orders',
  inventory: 'inventory',
  sync: 'sync',
};

const WORKSPACE_LABEL: Record<OpsActionItem['sourceDomain'], string> = {
  connect: 'Connect',
  orders: 'Orders',
  inventory: 'Inventory',
  sync: 'Connect / Sync',
};

const QUICK_LABEL: Record<OpsActionItem['sourceDomain'], string> = {
  connect: 'Open Connect',
  orders: 'Review orders',
  inventory: 'Review inventory',
  sync: 'Check sync health',
};

export function mapOpsItemToDecision(
  item: OpsActionItem,
  ctx: { sellerRef?: string; marketplace?: string; connectionId?: string | null },
): DecisionAction {
  const ts = item.timestamp || new Date().toISOString();
  return {
    id: item.id,
    priority: PRIORITY_MAP[item.priority],
    businessArea: AREA_MAP[item.sourceDomain] ?? 'other',
    title: item.title,
    description: item.description,
    evidence: item.evidence,
    confidence: item.confidence,
    createdAt: ts,
    updatedAt: ts,
    sourceWorkspace: WORKSPACE_LABEL[item.sourceDomain] ?? 'Workspace',
    workspacePath: item.href,
    quickActionLabel: QUICK_LABEL[item.sourceDomain] ?? 'Open workspace',
    sellerId: ctx.connectionId ?? undefined,
    sellerLabel: ctx.sellerRef,
    marketplace: ctx.marketplace,
  };
}
